import React, { useEffect, useRef, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { forgotPasswordapi, otpApi } from "../network/Network";
import { setResetToken } from "../redux/Slices/AuthSlice";
import { useDispatch } from "react-redux";

const Otp = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const navigate = useNavigate();

	const { email } = location?.state ?? {};
	const [formErrors, setFormErrors] = useState([]);
	const [loading, setLoading] = useState(false);
	const [otp, setOtp] = useState(new Array(4).fill(""));
	const inputRefs = useRef([]);

	const TOTAL_TIME = 120; // 120 seconds = 2 minutes
	const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);

	useEffect(() => {
		const expiryTime = localStorage.getItem("otp_expiry_time");

		if (expiryTime) {
			const secondsLeft = Math.floor((Number(expiryTime) - Date.now()) / 1000);
			setTimeLeft(secondsLeft > 0 ? secondsLeft : 0);
		} else {
			const newExpiry = Date.now() + TOTAL_TIME * 1000;
			localStorage.setItem("otp_expiry_time", newExpiry);
			setTimeLeft(TOTAL_TIME);
		}
	}, []);

	useEffect(() => {
		if (timeLeft <= 0) return;

		const interval = setInterval(() => {
			setTimeLeft((prev) => {
				if (prev <= 1) {
					clearInterval(interval);
					localStorage.removeItem("otp_expiry_time");
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [timeLeft]);

	const formatTime = (seconds) => {
		const m = Math.floor(seconds / 60).toString();
		const s = (seconds % 60).toString().padStart(2, "0");
		return `${m}:${s}`;
	};

	// Handle OTP input change
	// const handleChange = (value, index) => {
	//   if (value.length === 1) {
	//     const newOtp = [...otp];
	//     newOtp[index] = value;
	//     setOtp(newOtp);

	//     // Move focus to next input if not on the last input
	//     if (index < 3 && value) {
	//       inputRefs.current[index + 1].focus();
	//     }
	//   }
	// };
	const handleChange = (value, index) => {
		const newOtp = [...otp];

		// Only allow numbers
		if (!/^\d?$/.test(value)) return;

		newOtp[index] = value;
		setOtp(newOtp);

		// If user entered a digit, move to next field
		if (value && index < 3) {
			inputRefs.current[index + 1]?.focus();
		}
	};

	//   Forgot Password Api
	const OtpHandler = (e) => {
		e.preventDefault();
		setLoading(true);

		let isValid = true;
		const errors = {
			otp: [],
		};

		// Check if OTP is filled and valid
		if (!otp || otp.length === 0 || otp.some((digit) => digit.trim() === "")) {
			errors.otp.push("OTP is required");
			isValid = false;
		}

		setFormErrors(errors);

		if (!isValid) {
			setLoading(false);
			return;
		}

		const otpCode = otp.join("");
		const data = { email: email, otp: otpCode };

		otpApi(data)
			.then((res) => {
				setFormErrors({});
				Swal.fire({
					position: "center",
					icon: "success",
					text: "An OTP has been sent to your email address",
					showConfirmButton: false,
					timer: 1500,
				});
				navigate("/create-new-password", {
					state: { email },
				});
				setLoading(false);
			})
			.catch((err) => {
				setFormErrors({});
				const errorMessage = Array.isArray(err?.response?.data?.errors?.otp)
					? err.response.data.errors.otp[0]
					: err?.response?.data?.message || "Something went wrong";

				Swal.fire({
					position: "center",
					icon: "error",
					text: errorMessage,
					showConfirmButton: false,
					timer: 1500,
				});
				setLoading(false);
			});
	};

	const ResendOtp = () => {
		let data = { email: email };
		forgotPasswordapi(data)
			.then((res) => {
				Swal.fire({
					position: "center",
					icon: "success",
					title: "OTP Resent Successfully!",
					showConfirmButton: false,
					timer: 1500,
				});

				dispatch(setResetToken(res?.data?.response?.data?.token));
				setLoading(false);
			})
			.catch((err) => {
				const errorMessage = Array.isArray(err?.response?.data?.errors?.email)
					? err.response.data.errors.email[0]
					: err?.response?.data?.message || "Something went wrong";

				Swal.fire({
					position: "center",
					icon: "error",
					text: errorMessage,
					showConfirmButton: false,
					timer: 1500,
				});

				setLoading(false);
			});
	};
	console.log("email", email);
	//   =================
	return (
		<>
			<div className="main-banner-heading1">
				<Header />
			</div>
			<section className="signin">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="main-bg-signin">
								<h2 className="main-heading level-2 text-center mt-3 mb-3 main-heading-font dark-color wow animate__animated animate__zoomIn">
									OTP
								</h2>
								<div>
									<h4 className="primary-regular-font text-center mt-3 level-7 text-decoration-none mb-0">
										We’ve sent a 4-digit OTP via email. It will expire in{" "}
										<span>{formatTime(timeLeft)}</span>
									</h4>
								</div>
								<div className="row mt-4">
									{otp.map((_, index) => (
										<div
											className="col-lg-3 col-md-3 col-sm-3 col-3 mt-3"
											key={index}
										>
											<div className="form-group">
												{/* <input
                          type="number"
                          className="form-control text-center"
                          maxLength={1}
                          value={otp[index]}
                          onChange={(e) => handleChange(e.target.value, index)}
                          ref={(el) => (inputRefs.current[index] = el)}
                          placeholder="0"
                        /> */}
												<input
													type="text"
													className="form-control text-center"
													maxLength={1}
													value={otp[index]}
													onChange={(e) => handleChange(e.target.value, index)}
													onKeyDown={(e) => {
														if (e.key === "Backspace") {
															const newOtp = [...otp];
															newOtp[index] = "";
															setOtp(newOtp);

															// Only move focus back if current input is already empty
															if (index > 0 && otp[index] === "") {
																inputRefs.current[index - 1]?.focus();
															}
														}
													}}
													ref={(el) => (inputRefs.current[index] = el)}
													placeholder="0"
												/>
											</div>
										</div>
									))}
									<p className="forms-error mt-3">{formErrors?.otp}</p>
								</div>
								<div class="row">
									<div class="col-lg-12">
										<button
											class="resend-otp main-heading-font dark-color  log-in mt-1 level-7 primary-regular-font text-decoration-none border-0"
											style={{ background: "none" }}
											onClick={ResendOtp}
										>
											Resend OTP Code
										</button>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<Link
											onClick={OtpHandler}
											className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
											to="/create-new-password"
										>
											<span className="loading-btn loading bg-wrapper w-100">
												{loading ? <i className="fa fa-spinner"></i> : "Submit"}
											</span>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default Otp;
